<template>
  <article class="activity-story" data-activity-asset>
    <div class="activity-story__element">
      <AssetImage
        :id="data[0].id"
        ref="image"
        :controls="false"
        bg-color="transparent"
        :src="
          isOnline ? data[0].value : findPreloadedAsset('image', data[0].value)
        "
        @on-fullscreen-toggle="$emit('on-fullscreen-toggle', $event)"
      />
    </div>
    <div class="text-container">
      <span
        :style="{
          animationDuration: animDuration + 's',
          animationDelay: animDelay + 's',
        }"
        class="fadeTextIn"
        v-html="data ? data[0].label : ''"
      ></span>
    </div>
  </article>
</template>

<style lang="scss" scoped>
.activity-story {
  position: relative;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(340px, auto));

  height: 574px;

  background-color: transparent;
  margin: 4px 9px 0 9px;

  &__element {
    align-items: center;
    justify-content: center;

    width: 100%;
    height: calc(100dvh - 162px);
    max-width: calc((100dvh - 162px) * 0.935);

    border: none;

    animation-duration: 1s;
    animation-name: fade-in;
  }

  .text-container {
    background-color: $white100;

    display: flex;
    justify-content: center;
    align-items: center;

    font-size: 4vw;
    font-weight: bold;
    line-height: 4.2vw;
    color: $blue100;
    text-align: left;

    max-width: 98%;
    min-width: 50%;
    width: fit-content;
    min-height: 50px;

    margin: auto 7px auto 16px;
    padding: 15px 30px 15px 30px;

    border-radius: 10px;

    @media (max-width: 900px) {
      font-size: 3vw;
      line-height: 3.5vw;
    }
  }

  .fadeTextIn {
    opacity: 0;
    animation-name: fade-in;
    animation-fill-mode: forwards;
  }

  @keyframes fade-in {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
}
</style>

<script lang="ts">
import { Component, Prop, Ref, Watch, Vue } from 'vue-property-decorator';

import AssetImage from '@/components/Asset/Image.vue';
import EventBus from '@/utils/helpers/EventBus';
import { IActivityComponentData } from '@/models/interfaces/activities';
import { Getter } from 'vuex-class';
import { PreloadedAssetType } from '@/store/modules/preload-assets';

@Component({
  components: {
    AssetImage,
  },
})
export default class ActivityStoryImage extends Vue {
  @Prop({ required: true })
  private data!: IActivityComponentData;

  @Prop({ default: false, type: Boolean })
  private isCarouselItem!: boolean;

  @Prop({ default: 1 })
  private animDuration!: number;

  @Prop({ default: 0.4 })
  private animDelay!: number;

  @Ref('image')
  private image!: Vue;

  @Getter('preloadAssets/findPreloadedAsset')
  private findPreloadedAsset!: (
    type: PreloadedAssetType,
    originalUrl: string,
  ) => string;

  private showControls = true;

  public mounted() {
    EventBus.$on('activity-event-hide-fullscreen', () => {
      this.showControls = false;
    });
  }

  public beforeDestroy() {
    EventBus.$off('activity-event-hide-fullscreen');
  }
}
</script>
